var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkingLot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6328",
    "data-name": "Rectangle 6328",
    width: 40,
    height: 39.999,
    fill: "#353841"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34946",
    "data-name": "Group 34946",
    transform: "translate(-4473 -5405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6339",
    "data-name": "Rectangle 6339",
    transform: "translate(4473 5405)",
    fill: "#f1f5ff",
    stroke: "#353841",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34879",
    "data-name": "Group 34879",
    transform: "translate(4490 5422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34878",
    "data-name": "Group 34878",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24393",
    "data-name": "Path 24393",
    d: "M0,37.343a7.746,7.746,0,0,1,.668-1.166A2.064,2.064,0,0,1,2.311,35.5c.155,0,.309,0,.52,0v-.482q0-4.2,0-8.4a1.981,1.981,0,0,1,.024-.426.545.545,0,0,1,.618-.473.538.538,0,0,1,.522.536c.012.129.007.26.007.39v8.817H5.837v-.435q0-16.306,0-32.612a2.7,2.7,0,0,0-.027-.466.9.9,0,0,0-1.783.008A3.061,3.061,0,0,0,4,2.46Q4,12.831,4,23.2c0,.13,0,.261,0,.39a.591.591,0,0,1-.572.616.608.608,0,0,1-.593-.6c-.007-.078,0-.156,0-.234q0-10.545,0-21.091A2.132,2.132,0,0,1,4.316.091,2.089,2.089,0,0,1,7,2.03c.011.165,0,.331,0,.519H9.033c.014-.017.045-.036.045-.056,0-.865.5-1.294,1.523-1.287,3.853.029,7.707.011,11.56.012,1.068,0,1.429.361,1.429,1.427V14.322c0,.984-.39,1.378-1.364,1.378h-11.6c-1.114,0-1.365-.207-1.571-1.345H7.036V35.471c.29.019.561.023.829.056a2.225,2.225,0,0,1,1.974,2.166c.011.365-.018.731.008,1.094A1.118,1.118,0,0,1,9.141,40H.7L0,39.3V37.343M10.3,14.5H22.4V2.414H10.3ZM8.671,38.81v-.778c0-.983-.381-1.365-1.37-1.366q-2.38,0-4.759,0a2.893,2.893,0,0,0-.465.031,1,1,0,0,0-.879.867,12.366,12.366,0,0,0-.009,1.244Zm.4-32.226H7.04v3.752H9.074ZM7.03,5.344H9.08V3.764H7.03Zm.008,6.211v1.628c.637,0,1.245.007,1.853-.009a.293.293,0,0,0,.2-.205c.019-.463.009-.927.009-1.414Z",
    transform: "translate(0 0)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24394",
    "data-name": "Path 24394",
    d: "M34.53,41.485a1.649,1.649,0,0,1-1.156-1.85c.022-.361,0-.724,0-1.143h-.444q-2.284,0-4.568,0a1.571,1.571,0,0,1-.463-.048.481.481,0,0,1-.378-.593,1.1,1.1,0,0,1,.46-.5c.111-.074.3-.028.459-.028,3.189,0,6.379-.009,9.567.01.415,0,.492-.126.488-.506-.018-1.679.013-3.358-.014-5.037a3.706,3.706,0,0,0-.274-1.234c-.211-.557-.516-1.078-.748-1.628a.5.5,0,0,0-.555-.35c-3.241.011-6.483.007-9.723.007-3.541,0-7.083,0-10.624-.007a.559.559,0,0,0-.553.352,7.463,7.463,0,0,0-1.033,4.546c.09,1.23.022,2.472.026,3.709a.839.839,0,0,0,.035.137h10a4.127,4.127,0,0,1,.428.009.573.573,0,0,1,.055,1.137,2.358,2.358,0,0,1-.427.025H20.084c0,.377-.027.726,0,1.07a1.705,1.705,0,0,1-1.1,1.923H15.548a1.692,1.692,0,0,1-1.1-1.922c.019-.18,0-.365,0-.547,0-.331.027-.629-.319-.881a1.067,1.067,0,0,1-.29-.768q-.035-3.1,0-6.21a2.158,2.158,0,0,1,.213-.781c.253-.584.533-1.156.813-1.757-.1-.03-.182-.062-.266-.077a2.4,2.4,0,0,1,.373-4.769c.637-.014,1.276-.012,1.913,0a.383.383,0,0,0,.411-.265c.315-.686.661-1.355.975-2.041a2.605,2.605,0,0,1,2.6-1.623q5.877.022,11.755,0a2.566,2.566,0,0,1,2.553,1.574c.323.7.674,1.378.994,2.075a.411.411,0,0,0,.444.278c.651-.013,1.3-.022,1.953,0a2.4,2.4,0,0,1,.63,4.7c-.184.053-.377.081-.592.127.273.588.562,1.142.787,1.719a3.29,3.29,0,0,1,.257,1.127c.026,1.874.019,3.75.009,5.624a1.326,1.326,0,0,1-.521,1.274c-.07.044-.094.2-.1.307a9.039,9.039,0,0,0,0,.976,1.654,1.654,0,0,1-1.153,1.854ZM36.712,27.4c-.055-.13-.084-.213-.122-.292-.746-1.574-1.536-3.129-2.223-4.728A2.053,2.053,0,0,0,32.169,21c-3.618.055-7.237.02-10.856.022-.273,0-.546.019-.819.028a1.136,1.136,0,0,0-1.021.671c-.091.173-.19.341-.275.517q-1.157,2.427-2.312,4.858a2.762,2.762,0,0,0-.1.3ZM34.553,38.507c0,.513-.006.979,0,1.445a.328.328,0,0,0,.367.36c.859,0,1.72.011,2.577-.013.121,0,.334-.171.34-.275.036-.5.017-1,.017-1.517Zm-18.933,0c0,.511,0,.977,0,1.443a.32.32,0,0,0,.357.364c.859,0,1.718.011,2.576-.013.121,0,.331-.17.338-.273.037-.5.018-1,.018-1.521ZM36.872,24.953c.337.714.678,1.344.933,2.008.171.446.451.5.844.44a1.244,1.244,0,0,0,1.114-1.246,1.2,1.2,0,0,0-1.115-1.193c-.566-.04-1.136-.008-1.776-.008m-20.266-.006c-.62,0-1.163-.022-1.7.006a1.212,1.212,0,0,0-1.166,1.439,1.322,1.322,0,0,0,1.6,1.009.339.339,0,0,0,.187-.167c.354-.735.7-1.473,1.084-2.287",
    transform: "translate(-0.939 -1.486)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24395",
    "data-name": "Path 24395",
    d: "M22.166,33.744a2.457,2.457,0,0,1-4.913-.022,2.457,2.457,0,1,1,4.913.022m-1.172-.025A1.285,1.285,0,0,0,19.7,32.44a1.308,1.308,0,0,0-1.276,1.305,1.281,1.281,0,0,0,1.3,1.267,1.264,1.264,0,0,0,1.267-1.294",
    transform: "translate(-1.291 -2.34)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24396",
    "data-name": "Path 24396",
    d: "M35.647,36.186a2.459,2.459,0,1,1,2.464-2.444,2.463,2.463,0,0,1-2.464,2.444m0-1.172a1.271,1.271,0,0,0,1.3-1.268,1.291,1.291,0,0,0-1.269-1.3,1.31,1.31,0,0,0-1.3,1.279,1.286,1.286,0,0,0,1.278,1.294",
    transform: "translate(-2.484 -2.34)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24397",
    "data-name": "Path 24397",
    d: "M27.58,36.49c-.936,0-1.873,0-2.81,0-.476,0-.717-.2-.716-.579s.251-.588.716-.589q2.83-.007,5.658,0c.451,0,.727.237.727.59s-.269.576-.727.578c-.949,0-1.9,0-2.849,0",
    transform: "translate(-1.8 -2.643)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24398",
    "data-name": "Path 24398",
    d: "M27.582,32.465c.962,0,1.925-.007,2.887,0,.524.006.846.412.617.8a.776.776,0,0,1-.543.347c-1.963.025-3.927.02-5.891.01a.545.545,0,0,1-.6-.578.565.565,0,0,1,.64-.579c.962-.01,1.924,0,2.887,0",
    transform: "translate(-1.8 -2.43)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24399",
    "data-name": "Path 24399",
    d: "M15.78,9.895c0,1.071.017,2.084-.015,3.1a.813.813,0,0,1-.315.563.622.622,0,0,1-.565-.028.714.714,0,0,1-.265-.517q-.024-4.271-.008-8.543a.564.564,0,0,1,.607-.619c.909-.008,1.823-.035,2.729.031a3,3,0,0,1,.245,5.933,15.122,15.122,0,0,1-1.788.081c-.192.007-.385,0-.625,0m.025-1.18c.661,0,1.271.024,1.88-.006a1.887,1.887,0,0,0,1.8-1.685,1.777,1.777,0,0,0-1.369-1.917,17.573,17.573,0,0,0-2.312-.127Z",
    transform: "translate(-1.093 -0.287)",
    fill: "#353841"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingLot);
export default __webpack_public_path__ + "static/media/parkingLot.03198532bde6eb5f8c31b36e5f9a94d5.svg";
export { ForwardRef as ReactComponent };